/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.CustomsClearanceResponseDto>>;
export function request(
  params: API.tms.customsClearance.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
